
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ensureAvatarBucketExists } from './lib/createAvatarBucket.ts';

// Try to ensure the avatars bucket exists when the app loads
ensureAvatarBucketExists().catch(console.error);

// Explicitly create root with React 18
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
